// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fade-enter-active[data-v-5fe4fdfa], .fade-leave-active[data-v-5fe4fdfa] {\n  transition: opacity .5s;\n}\n.fade-enter[data-v-5fe4fdfa], .fade-leave-to[data-v-5fe4fdfa] /* .fade-leave-active below version 2.1.8 */ {\n  opacity: 0;\n}\n", ""]);
// Exports
module.exports = exports;
